window.Lemonade = window.Lemonade || {};

Shopify.handleize = function (str) {
	return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

// Global selectors and values
Lemonade.cacheSelectors = function(){

	Lemonade.cache = {

		// General
		$win: $(window),
		$body: $('html,body'),
		$back_to_top: $('#BackToTop'),

		// Header & Nav
		$header: $('#AppHeader'),
		$app_promo: $('#AppPromo'),
		header_specs: null,
		$search_input: $('#LiveSearchInp'),

		// Cart
		$cartCount: $('.CartCount'),
		$cart_flyout: $('#AppCart')

	};

};

// Kick off functions
Lemonade.init = function(){
	Lemonade.cacheSelectors();
	Lemonade.fastClick();
	Lemonade.lazyLoad();
	Lemonade.animateIn();
	Lemonade.globalHeader();
	Lemonade.billboards();
	Lemonade.accordion();
	Lemonade.slick();
	Lemonade.autoResponsiveElements();
	Lemonade.cache.$win.load(function(){
		Lemonade.fitVids();
	});
	Lemonade.productMedia();
	Lemonade.sticky();
	Lemonade.backToTop();
	Lemonade.productZoom();
	Lemonade.customProductSelects();
	Lemonade.customSelects();
	Lemonade.initCartFlyout();
	Lemonade.cartNote();
	Lemonade.gdpr();
	Lemonade.collectionAjaxLoad();
	Lemonade.liveSearch();
	Lemonade.mobileFooter();
	Lemonade.tooltips();
};

// Fastclick library dependancy https://github.com/ftlabs/fastclick
// Remove mobile click delay
Lemonade.fastClick = function(){
	FastClick.attach(document.body);
};

// Lazy Load library dependancy http://jquery.eisbehr.de/lazy
// Dynamically load images
Lemonade.lazyLoad = function(){
	$('.Lazy').Lazy({
		effect: 'fadeIn',
		effectTime: 300,
		visibilityOnly: true,
		// placeholder: 'https://cdn.shopify.com/s/files/1/0039/6581/2845/products/Screenshot_at_Jun_07_09-51-21_grande.png?v=1559890350', // 1px transparent png
		onError: function(element){
			console.log('error loading ' + element.data('src'));
		},
		afterLoad: function(element) {
			Lemonade.matchHeight();
			Lemonade.productZoom();
		}
	});
};

// Return window scrollTop
Lemonade.windowScrollTop = function(){
	return $(window).scrollTop();
};

// Body no scroll
Lemonade.scrollYes = function(){
	Lemonade.cache.$body.removeClass('NoScroll');
};

// Body yes scroll
Lemonade.scrollNo = function(){
	Lemonade.cache.$body.addClass('NoScroll');
};

// Library dependancy https://github.com/liabru/jquery-match-height
// jQuery Match Height
Lemonade.matchHeight = function(){
	var $product_item = $('.GridWrapper .GridItem');
	$('.MH').matchHeight();
	$product_item.find('.MhImage').matchHeight();
	$product_item.find('.MhDetails').matchHeight();
};

// Library dependancy https://github.com/protonet/jquery.inview
// Animate Elements when inview
Lemonade.animateIn = function(){
	$('.AnimateIn').on('inview', function(event, isInView) {
	  if (isInView) {
		$(this).addClass('InView');
	  } else {
		$(this).removeClass('InView');
	  }
	});
};

// Return a bunch of header specs
Lemonade.headerCalculations = function(){

  var is_transparent_header = false;

  if(Lemonade.cache.$body.hasClass('template-index')){
	  is_transparent_header = true;
  }

  if(liquid_vars.transparent_header){
	  if(liquid_vars.sticky_header){
		if(is_transparent_header){
			  total_offset = Lemonade.cache.$app_promo.outerHeight();
		} else {
			total_offset = Lemonade.cache.$header.outerHeight() + Lemonade.cache.$app_promo.outerHeight();
		}
	} else {
		  total_offset = 0;
	}
  } else {
	  if(liquid_vars.sticky_header){
		  total_offset = Lemonade.cache.$header.outerHeight() + Lemonade.cache.$app_promo.outerHeight();
	} else {
		  total_offset = 0;
	}
  }

  Lemonade.cache.header_specs = {
	  header_height: Lemonade.cache.$header.outerHeight(),
	  bar_height: Lemonade.cache.$app_promo.outerHeight(),
	  header_plus_bar: Lemonade.cache.$header.outerHeight() + Lemonade.cache.$app_promo.outerHeight(),
	  total_offset: total_offset
  };

  return Lemonade.cache.header_specs;

};

// Global Header + Navigation
Lemonade.globalHeader = function(){

	// init settings and selectors
	var $main_content = $('.MainContent'),
		$app_nav = $('#AppNav'),
		$app_nav_bg = $('#AppNavBg'),
		$app_search = $('#AppSearch'),
		$app_search_bg = $('#AppSearchBg'),
		$app_cart = $('#AppCart'),
		$app_cart_bg = $('#AppCartBg'),
		$app_search_bg = $('#AppSearchBg'),
		$btn_menu = $('#BtnMenu'),
		$btn_search = $('#BtnSearch'),
		$btn_cart = $('#BtnCart'),
		$tp = $('.TransitionPoint'),
		len = $tp.length,
		win_pos,
		tp_pos,
		state,
		winState;

	//-- FUNCTIONS ---//

	// Check state of window width (wide vs narrow screen)
	var winState = function() {
		win_width = Lemonade.cache.$win.width();
		if(win_width > 1023){
			if (state != 'max') {
				state = 'max';
				changedstate(state);
			};
		} else if (win_width > 767 && win_width <= 1023){
			if (state != 'desktop') {
				state = 'desktop';
				changedstate(state);
			};
		} else {
			if (state != 'mobile') {
				state = 'mobile';
				changedstate(state);
			};
		}
	}

  // If/When window crosses the wide/narrow threshold you can do some stuff here
	function changedstate(mystate){
		if(mystate == 'max'){
			Lemonade.cache.$body
				.removeClass('NarrowScreen WideScreen')
				.addClass('MaxScreen');
			// Close mobile menu if going to wide screen
			closeMenu();
		} else if(mystate == 'desktop'){
			// Do wide screen stuff here
			Lemonade.cache.$body
			  .removeClass('NarrowScreen MaxScreen')
				.addClass('WideScreen');
	  } else {
		  // Do narrow screen stuff here
		  Lemonade.cache.$body
			.removeClass('WideScreen MaxScreen')
			  .addClass('NarrowScreen');
	  }
	}


  // This function handles all the logic for determing offset positioning of elements affected by
  // sticky header, global promo bar and scrolled state of site header
	function headerOffsets(){

		// get the current header specs/dimensions
		Lemonade.headerCalculations();

		// Push the site header down from under the fixed promo bar
		Lemonade.cache.$header.css('top', Lemonade.cache.header_specs.bar_height);

		// Push the page content down from under the fixed header/fixed header + fixed promo bar
		$main_content.css('padding-top', Lemonade.cache.header_specs.total_offset);
	}


	// Header Utilities (toggle items visible/hidden)
	function headerUtilities(){
		var $utility_trigger = $('.UtilTrigger');

		$utility_trigger.click(function(){
			$me = $(this);

			$me.siblings().removeClass('Active');
			$('.UtilItem').removeClass('Show');

			if($me.hasClass('Active')){
				$me.removeClass('Active');
				$me_item = $me.data('utility');
				$('#'+$me_item).removeClass('Show');
			} else {
				$me.addClass('Active');
				$me_item = $me.data('utility');
				$('#'+$me_item).addClass('Show');
			}
		});
	}

	// Header transition on scroll
	var transitionPoint = function(){

		// get the current header specs/dimensions
		Lemonade.headerCalculations();
		//headerCalcs();

		// get window scroll position
		win_pos = Lemonade.cache.$win.scrollTop();

		// if transition point trigger exists in the DOM continue
		if(len > 0){
			// get the offset of the transition point trigger
		  tp_pos = $tp.offset().top;
		  // if scrolled beyond transition point do stuff
			if(win_pos > tp_pos){
				if(!Lemonade.cache.$header.hasClass('ScrolledPast')){
					Lemonade.cache.$header.addClass('ScrolledPast');
				}
			} else {
				if(Lemonade.cache.$header.hasClass('ScrolledPast')){
					Lemonade.cache.$header.removeClass('ScrolledPast');
				}
			}
		}
	};

  // Keep closing panels visible only for their exit animation. They stop
  // accepting focus immediately; reopening cancels the pending cleanup.
  function preparePanel($panel) {
    clearTimeout($panel.data('exitTimer'));
    $panel.removeClass('PanelClosing').removeAttr('inert');
    $panel[0].style.removeProperty('--panel-exit-start');
  }

  function closeSlidingPanel($panel, restoreFocus) {
    var panel = $panel[0];
    var animate = $panel.hasClass('AppSideShow') && window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    var transform = animate ? window.getComputedStyle(panel).transform : '';
    preparePanel($panel);
    $panel.removeClass('AppSideShow');
    ErieAccessibility.close(panel, restoreFocus);
    if (!animate) return;
    panel.style.setProperty('--panel-exit-start', transform === 'none' ? 'translate3d(0, 0, 0)' : transform);
    $panel.attr('inert', '').addClass('PanelClosing');
    $panel.data('exitTimer', setTimeout(function () {
      $panel.removeClass('PanelClosing');
      panel.style.removeProperty('--panel-exit-start');
    }, 200));
  }

	// Close menu
	var closeMenu = function(restoreFocus){
		$btn_menu.removeClass('ExpandBtn');
    closeSlidingPanel($app_nav, restoreFocus);
		$app_nav_bg.fadeOut();
		Lemonade.cache.$body.removeClass('NoScroll');
	};

	// Close search
	var closeSearch = function(restoreFocus){
    $btn_search.removeClass('Opened');
    closeSlidingPanel($app_search, restoreFocus);
		$app_search_bg.fadeOut();
		Lemonade.cache.$body.removeClass('NoScroll');
	};

	// Close cart
	var closeCart = function(restoreFocus){
    $btn_cart.removeClass('Opened');
    closeSlidingPanel($app_cart, restoreFocus);
		$app_cart_bg.fadeOut();
		Lemonade.cache.$body.removeClass('NoScroll');
	};

  //-- EVENTS AND FUNCTION CALLS ---//

  function setPanels(){
    var spacer;
    if(Lemonade.cache.$body.hasClass('NarrowScreen')){
      spacer = 0;
    } else {
      spacer = 12;
    }
    $('.AppSide').css({
      height: Lemonade.cache.$win.height() - Lemonade.cache.header_specs.header_plus_bar - spacer,
      top: Lemonade.cache.header_specs.header_plus_bar + spacer
    });
  }

  Lemonade.cache.$win.resize(function(){
    setPanels();
  });

	// Open menu
	$btn_menu.on('click', function(){
    setPanels();
		if ($app_nav.hasClass('AppSideShow')) {
			closeMenu();
		} else {
			if ($app_search.hasClass('AppSideShow')) {
				closeSearch();
			}
			if ($app_cart.hasClass('AppSideShow')) {
				closeCart();
			}
			$btn_menu.addClass('ExpandBtn');
      preparePanel($app_nav);
			$app_nav.addClass('AppSideShow');
      ErieAccessibility.open($app_nav[0], $btn_menu[0], closeMenu);
			$app_nav_bg.fadeIn();
			Lemonade.cache.$body.addClass('NoScroll');
		}
	});

	$btn_search.on('click', function(){
    setPanels();
		if ($app_search.hasClass('AppSideShow')) {
			closeSearch();
		} else {
			if ($app_nav.hasClass('AppSideShow')) {
				closeMenu();
			}
			if ($app_cart.hasClass('AppSideShow')) {
				closeCart();
      }
      $btn_search.addClass('Opened');
      preparePanel($app_search);
			$app_search.addClass('AppSideShow');
      ErieAccessibility.open($app_search[0], $btn_search[0], closeSearch, "#LiveSearchInp");
			$app_search_bg.fadeIn();
			Lemonade.cache.$body.addClass('NoScroll');
			Lemonade.cache.$search_input.focus();
		}
	});

	$btn_cart.on('click', function(){
    setPanels();
		if ($app_cart.hasClass('AppSideShow')) {
			closeCart();
		} else {
			if ($app_nav.hasClass('AppSideShow')) {
				closeMenu();
			}
			if ($app_search.hasClass('AppSideShow')) {
				closeSearch();
			}
      preparePanel($app_cart);
      $app_cart.addClass('AppSideShow');
      ErieAccessibility.open($app_cart[0], $btn_cart[0], closeCart);
      $btn_cart.addClass('Opened');
			$app_cart_bg.fadeIn();
			Lemonade.cache.$body.addClass('NoScroll');
		}
  });
  
  function headerDate(){
    var nD = new Date(),
        tD = nD.getDay(),
        dMsg = null;

    if(tD == 0){
      dMsg = liquid_vars.sun;
    } else if(tD == 1){
      dMsg = liquid_vars.mon;
    } else if(tD == 2){
      dMsg = liquid_vars.tue;
    } else if(tD == 3){
      dMsg = liquid_vars.wed;
    } else if(tD == 4){
      dMsg = liquid_vars.thr;
    } else if(tD == 5){
      dMsg = liquid_vars.fri;
    } else {
      dMsg = liquid_vars.sat;
    }

    $('#todayD').html(dMsg);

  }


	// Close side panels
	$('.CloseMenu').on('click', closeMenu);
	$('.CloseSearch').on('click', closeSearch);
	$('.CloseCart').on('click', closeCart);

	headerOffsets(0, true);

	transitionPoint();

	winState();

  headerUtilities();
  
  headerDate();

	Lemonade.cache.$win.on({
		scroll: function(){
			transitionPoint();
		},
		resize: function(){
			headerOffsets(0, false);
			winState();
		}
	});

};

// Billboards and Heros
Lemonade.billboards = function(){

	var $billboard_bg = $('.BillboardBGImg, .BillboardBGVideo');

	function billboard(el){
		Lemonade.headerCalculations();
		$me = el;
		win_height = Lemonade.cache.$win.height();
		billboard_height = win_height - Lemonade.cache.header_specs.total_offset;
		$me.height(billboard_height);
	}

	billboard($billboard_bg);

	Lemonade.cache.$win.resize(function(){
		billboard($billboard_bg);
	});

};

// Content accordions
Lemonade.accordion = function() {
  var $triggers = $('.AccTrigger');
  function duration() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
  }
  $triggers.attr('aria-expanded', 'false');
  $triggers.next('.AccContent').attr({'aria-hidden': 'true', inert: ''});
  $triggers.on('click', function(event) {
    event.preventDefault();
    var $trigger = $(this);
    var opening = !$trigger.hasClass('Open');
    var $content = $trigger.next('.AccContent');
    var speed = duration();
    $triggers.removeClass('Open').attr('aria-expanded', 'false');
    $triggers.next('.AccContent').not(opening ? $content : $()).each(function() {
      if (this.contains(document.activeElement)) $(this).prev('.AccTrigger').focus();
      $(this).attr({'aria-hidden': 'true', inert: ''}).stop(true, false).slideUp(speed);
    });
    if (opening) {
      $trigger.addClass('Open').attr('aria-expanded', 'true');
      $content.removeAttr('inert').attr('aria-hidden', 'false').stop(true, false).slideDown(speed);
    }
  });
};

// Library dependancy https://github.com/kenwheeler/slick/
// Slick init
Lemonade.slick = function(){

	var $slick = $('.Slick'),
		$product_images = $('.ProductSlick');

	$slick.on('init', function(){
		Lemonade.slickAlignArrows();
  });

	$slick.slick({
		lazyLoad: 'ondemand'
	});

	$slick.on('lazyLoaded', function (e, slick, image, imageSource) {
		if(image.hasClass('ImgToBG')){
			image.parent().css('background-image', 'url("' + imageSource + '")').addClass('Show');
			image.hide();
		}
  });

  $product_images.slick({
    lazyLoad: 'ondemand'
  });

	Lemonade.cache.$win.on({
		resize: function(){
			if(Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')){
				if($product_images.hasClass('slick-initialized')){
					$product_images.slick('unslick');
				}
			} else {
				if(!$product_images.hasClass('slick-initialized')){
					$product_images.slick({
						lazyLoad: 'ondemand'
					});
				}
			}
		}
	});

};

// Slick carousel vertically align prev/next arrows to carousel item image
Lemonade.slickAlignArrows = function(){

	setTimeout(function(){

		$('.SliderWrap').each(function(i, el){
			$me = $(el);
			if($me.hasClass('carousel')){
				img_height = $me.find('.slick-slide').first().find('img').first().height() / 2;
			  $me.find('.slick-arrow').css({'top': img_height});
			} else {
				$('.SlideArrow').addClass('init');
			}

		});
	}, 500);

};

Lemonade.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),
	  $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
	// Add wrapper to make video responsive
	$(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
	// Re-set the src attribute on each iframe after page load
	// for Chrome's "incorrect iFrame content on 'back'" bug.
	// https://code.google.com/p/chromium/issues/detail?id=395791
	// Need to specifically target video and admin bar
	this.src = this.src;
  });
};

// Video embed sizing http://fitvidsjs.com/
Lemonade.fitVids = function(){
	Lemonade.cache.$body.find('.video-wrapper').fitVids();
};

// PDP thumb scroll
Lemonade.productMedia = function() {

	var instance = $('.ProductVideo').data('vide'),
			$product_thumbs = $('.ProductThumbs'),
			$product_slider = $('#ProductSlick'),
			$play_btn = $('.PlayBtn');

	$('.ProductThumb').click(function(e){
		var $me = $(this),
				me_image,
				scroll_to;

		Lemonade.headerCalculations();

		if(!$me.hasClass('Active')){
			$me.addClass('Active').siblings('.ProductThumb').removeClass('Active');
			me_image = $me.attr('data-scroll-trigger');
			scroll_to = $('#'+me_image).offset().top;
			Lemonade.cache.$body.animate({scrollTop: scroll_to - Lemonade.cache.header_specs.total_offset});
			if(instance){
				vid = instance.getVideoObject();
				vid.pause();
				$('.PlayBtn')
					.find('.Pause')
					.hide()
					.end()
					.find('.Play')
					.show();
			}
		}
	});

	$('.ProductVideo').click(function(){
		var $me = $(this).next('.PlayBtn');
		if(instance){
			vid = instance.getVideoObject();
			if (vid.paused) {
				$me
					.find('.Play')
					.hide()
					.end()
					.find('.Pause')
					.show();
				vid.play();
			} else {
				$me
					.find('.Pause')
					.hide()
					.end()
					.find('.Play')
					.show();
				vid.pause();
			}
		}
	});
};

// PDP sticky sidebar
Lemonade.sticky = function(){

	Lemonade.cache.$win.on({
		load: function(){
			if(!Lemonade.cache.$body.hasClass('NarrowScreen')){
				stickyKit();
			}
		},
		resize: function(){
			if(Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')){
				stickyKit();
			} else {
				detachStickyKit();
			}
		}

	});

	function detachStickyKit(){
		$("ProductDetails, #ProductThumbs").trigger("sticky_kit:detach");
	}

	function stickyKit(){
		$("#ProductDetails, #ProductThumbs").stick_in_parent({
			offset_top: 100,
			// recalc_every: 1000,
			parent: '#ProductUpper'
		});
	}

}

// Back to top
Lemonade.backToTop = function(){

	if(Lemonade.cache.$back_to_top.length > 0){
		var grid_pos;

		function showBackToTop(){
			grid_pos = $('.GridWrapper').offset().top;
			if(Lemonade.windowScrollTop() > grid_pos){
				Lemonade.cache.$back_to_top.fadeIn();
			} else {
				Lemonade.cache.$back_to_top.fadeOut();
			}
		}

		Lemonade.cache.$back_to_top.click(function(){
			Lemonade.cache.$body.animate({'scrollTop': 0});
		});

		Lemonade.cache.$win.scroll(function(){
			showBackToTop();
		});
	}

};

// Product Zoom
Lemonade.productZoom = function(){
  if(liquid_vars.zoom_type == 'takeover'){
		var $takeover = $('#Takeover');
		$('.TakeoverImg').click(function(){
			src = $(this).attr('src');
			larger_src = src.replace('1024x1024', '2048x2048');
			$takeover.find('img').attr('src', larger_src);
			$takeover.fadeIn(function(){
				Lemonade.scrollNo();
			});
		});

		$takeover.click(function(){
			$takeover.fadeOut(function(){
				$takeover.find('img').attr('src', '');
				Lemonade.scrollYes();
			});
	});
  } else if(liquid_vars.zoom_type == 'window'){
	$(".ProductImage .Zoom").elevateZoom({
			zoomType: "inner",
			cursor: "crosshair"
		});
  }

};

// Product custom selects
Lemonade.customProductSelects = function() {
  $('.selector-wrapper').each(function(index) {
    var $wrapper = $(this);
    var $select = $wrapper.find('.single-option-selector');
    var $label = $wrapper.find('label').first();
    if (!$select.length || $wrapper.hasClass('accessible-selector')) return;
    var id = $select.attr('id') || 'product-option-' + index;
    var labelId = id + '-label';
    var valueId = id + '-value';
    var listId = id + '-list';
    var isSize = /size/i.test($label.text());
    $wrapper.addClass('accessible-selector');
    if (!$label.length) $label = $('<label>').text('Product option').prependTo($wrapper);
    $label.attr('id', labelId).addClass('a11y-label');
    $wrapper.find('label').addClass('a11y-label');
    // Keep Shopify's select and change callback as the source of variant values.
    $select.attr({'tabindex': '-1', 'aria-hidden': 'true', 'hidden': 'hidden'}).hide();
    var $button = $('<button type="button" class="OptionBox"></button>').attr({
      'aria-haspopup': 'listbox', 'aria-expanded': 'false',
      'aria-controls': listId, 'aria-labelledby': labelId + ' ' + valueId
    });
    var $title = $('<span class="OptionTitle"></span>').attr('id', valueId).appendTo($button);
    $button.append('<span class="icon icon-arrow" aria-hidden="true"><svg><use xlink:href="#icon-down"></use></svg></span>');
    var $list = $('<ul class="OptionSelect" role="listbox" tabindex="-1" hidden></ul>').attr({id: listId, 'aria-labelledby': labelId});
    $wrapper.prepend($list).prepend($button);
    var activeIndex = 0;
    var options = $select.find('option').toArray();
    var typeahead = '';
    var typeaheadTimer;
    options.forEach(function(option, i) {
      $('<li role="option"></li>').attr({
        id: listId + '-' + i, 'data-option-index': i,
        'aria-selected': option.selected ? 'true' : 'false',
        'aria-disabled': option.disabled ? 'true' : 'false'
      }).text(isSize && i === 0 ? "Don't Resize" : option.text).appendTo($list);
    });
    var $items = $list.children();
    function isOpen() { return $button.attr('aria-expanded') === 'true'; }
    function highlight(i) {
      if (!options[i] || options[i].disabled) return;
      activeIndex = i;
      $items.removeClass('KeyboardFocus').eq(i).addClass('KeyboardFocus');
      $list.attr('aria-activedescendant', listId + '-' + i);
      var item = $items[i];
      if (item && item.scrollIntoView) item.scrollIntoView({block: 'nearest'});
    }
    function sync() {
      options = $select.find('option').toArray();
      var selected = $select[0].selectedIndex;
      $items.each(function(i) {
        $(this).attr('aria-selected', i === selected ? 'true' : 'false')
          .attr('aria-disabled', options[i].disabled ? 'true' : 'false')
          .toggleClass('Active', i === selected);
      });
      $title.text(selected < 0 ? 'Select option' : $items.eq(selected).text());
      if (isOpen()) highlight(selected);
    }
    function open() {
      if (isOpen()) return;
      $list.prop('hidden', false).show();
      $button.addClass('Active').attr('aria-expanded', 'true');
      $list[0].focus();
      var selected = $select[0].selectedIndex;
      if (selected < 0 || options[selected].disabled) {
        selected = options.findIndex(function(option) { return !option.disabled; });
      }
      highlight(selected);
    }
    function close(restoreFocus) {
      if (!isOpen()) return;
      $button.removeClass('Active').attr('aria-expanded', 'false');
      $list.prop('hidden', true).hide().removeAttr('aria-activedescendant');
      $items.removeClass('KeyboardFocus');
      typeahead = '';
      clearTimeout(typeaheadTimer);
      if (restoreFocus) $button[0].focus();
    }
    function choose(i) {
      if (!options[i] || options[i].disabled) return;
      if ($select[0].selectedIndex !== i) $select.val(options[i].value).trigger('change');
      sync();
      close(true);
    }
    function step(direction) {
      for (var i = activeIndex + direction; i >= 0 && i < options.length; i += direction) {
        if (!options[i].disabled) { highlight(i); return; }
      }
    }
    $button.on('click', function() { if (isOpen()) close(true); else open(); });
    $button.on('keydown', function(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open();
      }
    });
    $list.on('keydown', function(event) {
      var key = event.key;
      if (key === 'Tab') {
        // Return to the trigger so the browser can continue normal Tab order.
        close(true);
        return;
      }
      if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' ', 'Escape'].indexOf(key) !== -1) {
        event.preventDefault();
        event.stopPropagation();
        if (key === 'ArrowDown') step(1);
        else if (key === 'ArrowUp') step(-1);
        else if (key === 'Home') { activeIndex = -1; step(1); }
        else if (key === 'End') { activeIndex = options.length; step(-1); }
        else if (key === 'Escape') close(true);
        else choose(activeIndex);
      } else if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault();
        typeahead += key.toLowerCase();
        clearTimeout(typeaheadTimer);
        typeaheadTimer = setTimeout(function() { typeahead = ''; }, 700);
        for (var offset = 1; offset <= options.length; offset++) {
          var candidate = (activeIndex + offset) % options.length;
          if (!options[candidate].disabled && $items.eq(candidate).text().toLowerCase().indexOf(typeahead) === 0) {
            highlight(candidate); break;
          }
        }
      }
    });
    $list.on('click', '[role="option"]', function() { choose(Number($(this).attr('data-option-index'))); });
    $select.on('change.accessibleSelector', sync);
    $(document).on('mousedown.accessibleSelector touchstart.accessibleSelector focusin.accessibleSelector', function(event) {
      if (!$wrapper[0].contains(event.target)) close(false);
    });
    sync();
  });
};

// Preserve optional legacy components without double-binding accessible selectors.
Lemonade.customSelects = function(){
	var $selector_wrapper = $('.selector-wrapper:not(.accessible-selector), .fake-select');

	$('body').on('click', '.selector-wrapper:not(.accessible-selector) .OptionSelect li', function(e){
		e.stopPropagation();
		var $me = $(this),
			$option_box = $me.closest('.OptionBox'),
			me_val = $me.data('val'),
			me_text = $me.text(),
			$me_selector_wrapper = $me.closest('.selector-wrapper');

		if (!$me.hasClass('Active')){
			$me
				.addClass('Active')
				.siblings('li')
				.removeClass('Active')
				.end()
				.closest('.selector-wrapper')
				.find('.single-option-selector')
				.val(me_val)
				.change();
		}

		if (!$me_selector_wrapper.hasClass('color')){
			if(liquid_vars.variant_style == 'dropdown'){

				$me
					.closest('ul')
					.fadeOut()
					.prev('.OptionBox')
					.removeClass('Active')
					.find('span')
					.not('.icon')
					.text(me_text);
			}
		}
	});

	$selector_wrapper.on('click', '.OptionBox', function(e){
		e.stopPropagation();
		var $me = $(this);
		if($me.hasClass('Active')){
			$me
                .attr("aria-expanded","false")
				.removeClass('Active')
				.next('.OptionSelect')
                .focus()
				.fadeOut();
		} else {
			$selector_wrapper.find('.OptionBox').removeClass('Active').next('.OptionSelect').fadeOut();
			$me
                .attr("aria-expanded","true")
				.addClass('Active')
				.next('.OptionSelect')
        .fadeIn();
      if($me.find('.OptionTitle').text() == 'Sort by' && Lemonade.cache.$body.hasClass('NarrowScreen')){
        Lemonade.scrollNo();
        $('#collection-sorting .OptionSelect').css({top: Lemonade.cache.header_specs.total_offset});
        $('#mobile-sort-active').fadeIn();

      }
		}
  });

  $('#mobile-sort-active').click(function(){
    $(this).add('.OptionSelect').fadeOut();
    $('.OptionBox').removeClass('Active');
    Lemonade.scrollYes();
  });

};

// Product Page
Lemonade.productPage = function(options){

  function updateAffirmPricing(price){
    affirm.ui.ready(
      function() {
        $('.affirm-as-low-as').attr('data-amount',price);
          affirm.ui.refresh();
      }
    );
  }

  var moneyFormat = options.money_format,
		variant = options.variant,
		isDefaultVariant = options.is_default_variant,
		translations = options.translations;

	// Selectors
	var $addToCart = $('#AddToCart'),
		$productPrice = $('#ProductPrice'),
		$comparePrice = $('#ComparePrice'),
		$quantityElements = $('.ProductQty'),
		$addToCartForm = $('#AddToCartForm'),
		$addToCartText = $('#AddToCartText'),
		$PreorderMessage = $('#PreorderMessage'),
		$productShippng = $('.ProductShipping'),
		$productVariatns = $('#ProductVariants'),
    $productIsDefaultVariant = $('#ProductIsDefaultVariant');

	if (variant) {

    updateAffirmPricing(variant.price);

    // Select a valid variant if available
		if (variant.available) {
			// Available, enable the submit button, change text, show quantity elements
			$addToCart.removeClass('disabled').removeClass('preorder').prop('disabled', false);
			$addToCartText.html(translations.add_to_cart);
			$quantityElements.show();
			$PreorderMessage.hide();
		} else {
			// Sold out, check for preorder, disable the submit button, change text, hide quantity elements
			$addToCart.addClass('disabled').prop('disabled', true);
			$quantityElements.hide();
		}

		// Regardless of stock, update the product price
		$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

		// Also update and show the product's compare price if necessary
		if (variant.compare_at_price > variant.price) {
			$comparePrice
			.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
			.show();
		} else {
			$comparePrice.hide();
		}

	} else {
		// The variant doesn't exist, disable submit button.
		// This may be an error or notice that a specific variant is not available.
		// To only show available variants, implement linked product options:
		//   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
		$addToCart.addClass('disabled').prop('disabled', true);
		$addToCartText.html(translations.unavailable);
		$quantityElements.hide();
	}

	$productIsDefaultVariant.val(isDefaultVariant);
  $('#ProductReturnPolicy').prop('disabled', !variant || isDefaultVariant);

	if ($productShippng.length) {
    if (isDefaultVariant) {
      $productShippng.show();
      $(".weekday-msg").hide();
    } else {
      $productShippng.hide();
      $(".weekday-msg").html(translations.shipping_resized).show();
    }
  }

  // product sold out contact form
  $('.sold-out-form-trigger').click(function(){
    $(this).hide();
    $('#contact_form').show();
    $('#ContactFormEmail').focus();
  });

  // if sold out form is submitted show the success message
  $.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                      .exec(window.location.search);

    return (results !== null) ? results[1] || 0 : false;
  }

  if($.urlParam('contact_posted') == 'true'){
    $('.sold-out-form-trigger').hide();
    $('#contact_form').show();
  }

};

// Add to cart button states
Lemonade.addToCartflip = function($addToCartBtn){
  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
	.clone(true)
	.prop('disabled', false)
	.removeClass('disabled')
	.addClass('btn--unflipped')
	.find('span')
	.text(liquid_vars.add_to_cart)
	.end()
	.hide()
	.insertAfter($addToCartBtn);

  $addToCartBtn
	.unbind('click')
	.removeClass('disabled')
    .attr('id', 'viewCart')
	.find('span')
	.text('View Cart')
	.end()
	.bind('click', function(e) {
	  e.preventDefault();
	  window.location.href = '/cart';
	})
	.prop('disabled', false)
	.addClass('btn--flipped');

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
	$(this).closest('form').find('.btn--flipped, .ContinueShopping, .note').remove();
	$(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

Lemonade.initCartFlyout = function(){
	var $addToCartBtn = $('form[action^="/cart/add"] :submit');

	getCartJSON(renderCartFlyout, false);

	function getCartJSON(callback, show_flyout){
		$.getJSON('/cart.js', function(cart) {
			if (typeof callback !== undefined) {
				Lemonade.cache.$cartCount.text(cart.item_count);
             
				callback(cart, show_flyout);
			}
		})
	}

	function renderCartFlyout(cart, show_flyout){
		cart.item_count === 0 ? Lemonade.cache.$cart_flyout.addClass('empty') : Lemonade.cache.$cart_flyout.removeClass('empty');
        cart.item_count > 1 ? $("#csdf-item").text("items") : $("#csdf-item").text("item")
    $('.CartCount').text(cart.item_count);

		// show cart flyout
		var source = $("#cart-template").html(),
		template = Handlebars.compile(source),
		items = [],
		img_small;

		$.each(cart.items, function(i,o){
			img_small = o.image ? o.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
			var properties = o.properties;
			if (properties && properties._isDefaultVariant) {
				if (properties._isDefaultVariant === 'true') {
					properties._isDefaultVariant = true;
				} else {
					properties._isDefaultVariant = false;
				}
			}
			items.push({
				id: o.id,
				vendor: o.vendor,
				title: o.product_title,
				url: o.url,
				qty: o.quantity,
				price: Shopify.formatMoney(o.discounted_price),
				image: img_small,
				option1: o.variant_options[0],
				classes: (o.discounted_price) ? '' : 'free-item',
				resize_message: (properties && properties['Return policy']) || liquid_vars.cart_msg,
				properties: properties,
			});
		});


    $('.subtotal-price', '#AppCart').html( Shopify.formatMoney( cart.total_price ) );
		$('.Products', '#AppCart').html( template({items:items}) );

		if (show_flyout) {
			showCartFlyout();
		}
	}

	function showCartFlyout(){
		Lemonade.cache.$cart_flyout.addClass('Show');
	}

	function hideCartFlyout(){
		Lemonade.cache.$cart_flyout.removeClass('Show');
	}

	function addToCart(e){
		e.preventDefault();
		var $addToCartBtn = $(this),
		$addToCartForm = $(this).closest('form'),
		$addToCartBtnText = $(this).find('span');
		$('.note.errors').remove();
		if ($addToCartForm.length === 0) return
		$addToCartBtn
			.attr('data-add-to-cart', $addToCartBtnText.text())
			.prop('disabled', true)
			.addClass('disabled btn--loading');
			$.ajax({
				url: '/cart/add.js',
				dataType: 'json',
				type: 'post',
				data: $addToCartForm.serialize(),
				success: function(lineItem) {
					$addToCartBtn
						.removeClass('btn--loading')
						.prop('disabled', false)
						.removeClass('disabled btn--loading');
					getCartJSON(renderCartFlyout, true);
					Lemonade.addToCartflip($addToCartBtn);
                   $("#cartLive").text("item added to your cart");
                  setTimeout(
                    ()=> $("#cartLive").text(""), 1500
                  )
				},
				error: function(XMLHttpRequest, textStatus) {
					var data = eval('(' + XMLHttpRequest.responseText + ')');
					var response = data.description;
					var status = XMLHttpRequest.status;
					$addToCartBtn.removeClass('btn--loading');
					if (status === 422 && $('#productSelect option').length === 1) {
						$addToCartBtnText.text(liquid_vars.sold_out);
					}
					else {
						$addToCartBtn.prop('disabled', false).removeClass('disabled');
						$addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
					}
					$addToCartBtn.after('<p class="note errors">' + response + '</p>');
				}
			});
	};

	function updateQuantity(el){
		var $button = $(el),
		$qty = $button.parent().find('.Quantity'),
		oldQty = $qty.val(),
		variant_id = $qty.data('variant');

		if ($button.hasClass('up')) {
			var newQty = parseFloat(oldQty) + 1;
		} else {
			if (oldQty > 0) {
				var newQty = parseFloat(oldQty) - 1;
			} else {
				newQty = 0;
			}
		}

		$qty.attr('value', newQty);
		updateCart(variant_id, newQty);
	}

	function removeProductFlyOut(el){
		var $button = $(el),
		$qty = $button.parent().find('.Quantity'),
		oldQty = $qty.data('quantity'),
		variant_id = $qty.data('variant');

		if ($button.hasClass('up')) {
			var newQty = parseFloat(oldQty) + 1;
		} else {
			if (oldQty > 0) {
				var newQty = parseFloat(oldQty) - 1;
			} else {
				newQty = 0;
			}
		}

		$qty.attr('value', newQty);
		updateCart(variant_id, newQty);
	}

	function updateCart(variant_id, quantity){
		var params = {
			type: 'POST',
			url: '/cart/change.js',
			data:  'quantity='+quantity+'&id='+variant_id,
			dataType: 'json',
			success: function(cart) {
				renderCartFlyout(cart, true);
              if(cart.item_count===0){
                $("#BtnCart").click().focus();
                setTimeout(()=>{
                  $("#AppCart").css("display","none");
                }, 1000)
              }
			},
			error: function(XMLHttpRequest, textStatus) {
				Shopify.onError(XMLHttpRequest, textStatus);
			}
		};

		$.ajax(params);
	}


	Lemonade.cache.$cart_flyout.on('click', '.remove_fluout', function(e, cart){
      e.preventDefault();
		removeProductFlyOut(this);
        $("#cartLive").text("item removed from your cart");
        setTimeout(()=> $("#cartLive").text(""), 1500);
       // console.log( $(".Products").children() )
	});

	$addToCartBtn.on('click', addToCart);

	//   Lemonade.cache.$win.on('resize', function(){
	//     resizeCartFlyout();
	//   });

	//   Lemonade.cache.$body.on('click', function(e){
	// 		e.stopPropagation();
	//     if($(e.target).attr('id') == 'CartTrigger'){
	//       Lemonade.cache.$cart_flyout.toggleClass('Show');
	//     } else if($(e.target).hasClass('icon-close')){
	// 	    Lemonade.cache.$cart_flyout.removeClass('Show');
	// 	  } else {
	//       if(!$(e.target).closest('#AppCart').length){
	//         Lemonade.cache.$cart_flyout.removeClass('Show');
	//       }
	//     }
	//   });

	return {
		renderCartFlyout: renderCartFlyout,
		showCartFlyout: showCartFlyout,
		hideCartFlyout: hideCartFlyout,
		addToCart: addToCart
	}
};

Lemonade.cartNote = function(){
	$('.NoteAdd').click(function(){
		$(this).hide();
		$('.CartNote').show();
	});
};

Lemonade.gdpr = function(){

	var $gdpr = $('#Gdpr');

	if (typeof $.cookie('gdpr-modal') === 'undefined') {
		setTimeout(function(){
			$gdpr.addClass('show');
		}, 1500);

		$('#GdprAgree').click(function(){
			var $me = $(this);
			if($me.is(':checked')){
				setTimeout(function(){
					$gdpr.removeClass('show');
				}, 400);
				$.cookie('gdpr-modal', '1', { expires: 90, path: '/' });
			}
		});
	}

};

Lemonade.collectionAjaxLoad = function(){

	var $load_more = $("#LoadMore"),
	load_more_text = $load_more.attr('data-button-text'),
	page_number = 1;

	// Load more products into the page via AJAX API
	function loadMoreProducts(me, page_number, path) {
		var wrap = me.closest('.btn-wrap').closest('.GridWrapper').find('.AjaxPager'),
				maxpage = me.data('maxpage'),
				the_query,
				url,
				json_path = 'json';

		if (!path) {
			path = location.pathname;
			the_query = location.search;

			if (the_query){
				url = path + the_query + '&page=' + page_number;
			} else {
				url = path + '?page=' + page_number;
			}
		}

		$.ajax({
			type: 'GET',
			dataType: 'html',
			url: url,
			data: the_query,
			success: function(data) {
				var $data = $(data),
						$new_wrap = $('<div class="NewPostsWrap"></div>'),
						$new_posts = $new_wrap.append($data.find(".AjaxPager").html()),
						wrap_index;

				if ($data.length) {
					wrap_index = page_number - 2;
					$(".AjaxPager").append($new_posts);
					$new_wrap = Lemonade.cache.$body.find('.NewPostsWrap');
					Lemonade.slickAlignArrows();
					if(!Lemonade.cache.$body.hasClass('collection-lifestyle') || Lemonade.cache.$body.hasClass('NarrowScreen')){
						$new_wrap.eq(wrap_index).find('.Slick, .SlickMobile').slick({
							lazyLoad: 'ondemand'
						});
					}
					Lemonade.lazyLoad();
					setTimeout(function(){
						$new_wrap.addClass('Show');
					}, 300);
					me.attr("disabled", false);
					if (maxpage === page_number) {
						me.hide();
						$('.LoadMoreWrapper').hide();
					} else {
						me.attr("disabled", false);
					}
				}
			},
			error: function(data) {
				return wrap.append('<div>Something Went Wrong</div>');
			}
		});
	}

	// Trigger AJAX Load more on collection page
	$load_more.click(function(e) {
		page_number++;
		loadMoreProducts($(this), page_number);
	});

};

Lemonade.liveSearch = function() {
	/// Live search
	// var preLoadLoadGif = $('<img src="{{ 'ajax-load.gif' | asset_url }}" />');
	var searchTimeoutThrottle = 500,
			searchTimeoutID = -1,
			currReqObj = null,
			$searchForm = $('#LiveSearchForm'),
			$searchInp = $('#LiveSearchInp'),
			$soldCheckbox = $('#LiveSearchSoldCheckbox'),
			$resultsBox = $('#LiveSearchResults'),
			$resultsBoxSold = $('#LiveSearchResultsSold');

  function runLiveSearch() {
    //Only search if search string longer than 2, and it has changed
    if ($searchInp.val().length > 2 && ($searchInp.val() != $searchInp.data('oldval') || $soldCheckbox.is(':checked') != $soldCheckbox.data('oldval'))) {
      //Reset previous value
      $searchInp.data('oldval', $searchInp.val());
      $soldCheckbox.data('oldval', $soldCheckbox.is(':checked'));

      // Kill outstanding ajax request
      if(currReqObj != null) currReqObj.abort();

      // Kill previous search
      clearTimeout(searchTimeoutID);

      //Search term
      var term = $searchForm.find('input[name="q"]').val();

      var isSoldEnabled = $soldCheckbox.is(':checked');

      //Show loading
      $resultsBox.html('<div class="livesearch-loading"></div>');
      $resultsBoxSold.empty().hide();

      // Do next search (in X milliseconds)
      searchTimeoutID = setTimeout(function(){
        //Ajax hit on search page
        currReqObj = $.ajax({
          url: $searchForm.attr('action'),
          data: {
            type: 'product',
            view: 'json',
            q: term,
            'options[prefix]': 'last',
          },
          dataType: 'json',
          success: function(data){
            currReqObj = null;
            if(data.results_total == 0) {
              //No results
              $resultsBox.html('<div class="livesearch-empty">No products found.</div>');
              $resultsBoxSold.empty().hide();
            } else {
              //Numerous results
              $resultsBox.empty();
              $resultsBoxSold.empty().hide();
              $.each(data.results, function(index, item){
                
                var xshow = 'wholesale'; //term for products we dont want to show
                if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                  var $row = $('<a class="livesearch-item"></a>').attr('href', item.url);
                  $row.append('<div class="livesearch-item-img"><img src="' + item.thumb + '" alt role="presentation '+'" /></div>');
                  $row.append('<div class="livesearch-item-title">'+item.title+'</div>');
                  if(item.available){
                    $resultsBox.append($row);
                  } else if (isSoldEnabled) {
                    $resultsBoxSold.append($row);
                  }
                }
              });
              if (!$resultsBoxSold.is(':empty')) {
                $resultsBoxSold.show();
              }
            }
          }
        });
      }, searchTimeoutThrottle);
    } else if ($searchInp.val().length <= 2) {
      //Deleted text? Clear results
      $resultsBox.empty();
      $resultsBoxSold.empty().hide();
    }
  }

  $searchInp.bind('keyup change', runLiveSearch);
  $soldCheckbox.bind('change', runLiveSearch);

	//Search box should mimic live search string: products only, partial match
	$('.search-form, #search-form').on('submit', function(e){
	  e.preventDefault();
	  var term = '*' + $(this).find('input[name="q"]').val() + '*';
	  var linkURL = $(this).attr('action') + '?type=product&q=' + term;
	  window.location = linkURL;
	});

}

Lemonade.mobileFooter = function() {
  var $trigger = $('#FooterMobileNavTrigger');
  var $dropdown = $('#FooterMobileNav');
  var $footerBg = $('#FooterBg');
  function setOpen(open) {
    $trigger.toggleClass('Open', open).attr('aria-expanded', String(open))
      .attr('aria-label', open ? 'Close info' : 'Info');
    $footerBg.stop(true, true)[open ? 'fadeIn' : 'fadeOut']();
    $dropdown.stop(true, true)[open ? 'slideDown' : 'slideUp']();
  }
  $trigger.on('click', function() { setOpen(!$trigger.hasClass('Open')); });
  $('.CloseFooterMobileNav').on('click', function() { setOpen(false); });
  $trigger.add($dropdown).on('keydown', function(e) {
    if (e.key === 'Escape' && $trigger.hasClass('Open')) {
      e.preventDefault();
      setOpen(false);
      $trigger.focus();
    }
  });
};

Lemonade.tooltips = function() {
  $('.TooltipTrigger').each(function() {
    var trigger = this;
    var $trigger = $(trigger);
    var $dialog = $($trigger.attr('data-tooltip'));
    if (!$dialog.length) return;
    $trigger.attr({'aria-controls': $dialog.attr('id'), 'aria-expanded': 'false', 'aria-haspopup': 'dialog'});
    function close(restoreFocus) {
      $trigger.removeClass('Opened');
      ErieAccessibility.close($dialog[0], restoreFocus);
    }
    $trigger.on('click', function() {
      if (!$dialog[0].hidden) { close(); return; }
      ErieAccessibility.open($dialog[0], trigger, close);
      $trigger.addClass('Opened');
    });
    $dialog.find('.TooltipClose').on('click', function() { close(); });
  });
};

// Initialize Lemonade JS on docready
$(Lemonade.init);
